export enum WeatherCode {
  Sun = 'sun',
  Cloud = 'cloud',
  Gray = 'gray',
  Snow = 'snow',
  Rain = 'rain',
}
